export default __webpack_public_path__ + "static/media/icon-empty.7cc0dc2f.svg";